<template>
<span class="file is-centered is-medium">
  <label class="file-label">
    <input
      class="file-input"
      type="file"
      id="choosenFiles"
      @change="choiceMade"
      multiple >
    <span class="file-cta" for="fileName">
      <span class="file-icon">
        <i class="fas fa-file-audio"></i>
      </span>
      <span class="file-label">
        Choose files...
      </span>
    </span>
  </label>
</span>
</template>

<script>
export default {
    name: 'ChooseFile',
    emits: ['choiceMade'],
    methods: {
        choiceMade(event){
            this.$emit('choiceMade', {files: event.target.files})
        },
    },
}
</script>
